import {formatDistance, formatDuration, Formatting} from "./formatting";

export const Camera = {}

Camera.install = function (Vue, options) {
  Vue.prototype.$getCamerasFromMask = (value) => {
    return getCamerasFromMask(value)
  }
  Vue.prototype.$getCameraName = (value) => {
    return getCameraName(value)
  }
}

export function getCamerasFromMask(mask) {
  let cameras = ""

  if ((mask & 0x1) === 0x1) {
    cameras += "Front "
  }
  if ((mask & 0x2) === 0x2) {
    cameras += "Rear "
  }
  if ((mask & 0x4) === 0x4) {
    cameras += "Left "
  }
  if ((mask & 0x8) === 0x8) {
    cameras += "Right "
  }
  if ((mask & 0x10) === 0x10) {
    cameras += "Driver "
  }

  return cameras
}

export function getCameraName(camera) {
  switch(camera) {
    case 1:
      return "Front"
    case 2:
      return "Rear"
    case 4:
      return "Left"
    case 8:
      return "Right"
    case 16:
      return "Driver"
  }
}
